export default __webpack_public_path__ + "static/4-9e5c68228ad8204e2a0ab15a94733d8c.jpeg";